import { useEffect, useState } from "react";
// import NavMenu from "./components/Nav";
import servicosProduto from "../servicos/servicos-produto";
import servicosImagens from "../servicos/servicos-imagens";
import { Link } from "react-router-dom";
import NavMobile from "./components/NavMobile";
import { basePath } from "../utils/baseUrl";

const ProdutosProducao = (props) => {
    const [produtos, setProdutos] = useState([]);
    const [imagens, setImagens] = useState([]);
    const [imagensProdutos, setImagensProdutos] = useState([]);


    useEffect(() => {
        servicosProduto
            .listarTodosCategoria2()
            .then((response) => {
                let aux = [];
                if (response.status === 200) {
                    for (const produto of imagens) {
                        let contem = false;
                        for (const iterator of response.data) {
                            if (String(produto.Produto[0].nome).trim() === String(iterator.nome).trim()) {
                                contem = true;
                            }
                        }
                        if (contem === true) {
                            aux.push(produto);
                        }
                    }
                    setProdutos(aux);
                } else {
                    console.log("não foi possível obter os produtos");
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [imagens]);

    useEffect(() => {
        servicosImagens
            .listarTodas()
            .then((response) => {
                if (response.status === 200) {
                    setImagens(response.data);
                } else {
                    console.log("não foi possível obter as imagens dos produtos");
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        let aux = [];
        for (const produto of produtos) {
            for (const iterator of imagens) {
                if (produto.id_produto === iterator.id_produto) {
                    aux.push(iterator);
                }
            }
        }
        const filteredArray = aux.filter(
            (obj, index, self) =>
                index ===
                self.findIndex((o) => o.Produto[0].nome === obj.Produto[0].nome)
        );
        setImagensProdutos(filteredArray);
    }, [produtos, imagens]);






    return <>
        {/* {!props.menu && <NavMenu />} */}
        <div className="container mt-5">
        {props.mn && <a className="subtitulo" style={{fontSize: 24}} href="/SolicitacoesExterna">Menu Anterior</a>}
            <div className="d-flex flex-wrap align-content-around justify-content-center">
                {imagensProdutos.map(item => {
                    return (
                        <Link key={item.id_produto} to={"/CardProducao"} state={{ produto: item }} style={{ height: 400 }} >
                            <div className="card d-flex justify-content-center align-items-center m-3 border-0" style={{ width: '16rem' }}>
                                <img className="border-1 border-bottom card-img-top" src={`${basePath}/${item.filename}`} style={{ height: 180, width: '100%' }}  alt="..." />
                                <div className="card-body text-center" style={{ width: '100%', height: 100 }}>
                                    <h5 className="card-title subtitulo" style={{ fontSize: 22 }}>$ {item.Produto[0].milhas}</h5>
                                    <h5 className="card-title subtitulo" style={{ fontSize: 22 }}>{item.Produto[0].nome}</h5>
                                </div>
                            </div>
                        </Link>
                    )
                })}
            </div>

        </div>
        <NavMobile />
    </>
}

export default ProdutosProducao;